import { type FC } from 'react';

export interface OfferInterstitialProps {
  title: string;
  description?: string;
  cover?: string;
  actionBtn: React.ReactNode;
}
export const OfferInterstitial: FC<OfferInterstitialProps> = ({
  actionBtn,
  title,
  description,
  cover,
}) => {
  return (
    <div className="md:py-15 flex flex-col gap-8 px-5 py-10">
      <div className="flex flex-col items-stretch gap-2 text-center">
        <h3 className="text-text400 text-2xl">{title}</h3>
        <div className="flex flex-col gap-5">
          {description && (
            <div className="text-text600 text-sm">{description}</div>
          )}
          {cover && (
            <div>
              {cover.includes('.mp4') ? (
                <video
                  autoPlay
                  className="w-full"
                  loop
                  muted
                  style={{ height: 'auto' }}
                >
                  <source src={cover} type="video/mp4" />
                </video>
              ) : (
                <img alt={title} className="w-full" src={cover} />
              )}
            </div>
          )}
        </div>
      </div>
      {actionBtn}
    </div>
  );
};
